<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ru81kd/tc-custom/9781439667316.jpg?1705026066274" alt="This image is the cover for the book Hidden Chicago Landmarks, Hidden History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden Chicago Landmarks, Hidden History
      </h1>
      <p class="bookDescription body article font2">
        <p>Take in the sights of Chicago's forgotten byways, including a cow trail through a downtown hotel. Pause reflectively at the cemetery in a working scrapyard and the church built without a nail. Stop by the one-time homes of Walt Disney, Joe Louis, Hillary Clinton and Al Capone. Along the way, greet forgotten Chicago notables like the vice president who won a Nobel Prize and wrote a number-one pop hit. From the shortest street to the oldest house, John R. Schmidt visits the sites of Chicago's neglected history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John R. Schmidt
      </h2>
      
      <p class="authorDescription body article">John R. Schmidt is a fifth-generation Chicagoan. He earned his PhD in history at the University of Chicago and has taught at all levels, from kindergarten through college, including more than thirty years in the Chicago Public School System. He has published nearly four hundred articles in magazines, newspapers, encyclopedias and anthologies. This is his fifth book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a6b9619